import Radio from 'components/Form/RadioButtonType'
import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'

//importing components
import { Checkbox } from 'antd'
import Control from 'components/Control/Control'
import Divider from 'components/Divider/Divider'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import AntdSelectNew from 'components/Form/SelectNew'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import Uploadloader from 'components/Uploader/Uploader'
import AddIcon from 'components/icons/AddIcon'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 14px;
  margin-left: 6px;
`
import { MonthList } from 'modules/Onboarding/Register/Education/constant'
import {
  RadioGroupNew,
  AdjustIcon,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { searchConfig } from 'utils/config'
import {
  Container,
  FormItem,
  Heading,
  IconView,
  SubHeading,
} from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import WorkExpAwardForm from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExpAwardForm'
import { Text } from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import moment from 'moment'
import CustomTag from 'components/CustomTag'

import {
  getValuebyName,
  mumericToBooleanConverter,
} from '../../../../utils/helpers'
import { LocalDiv, StyledFormItem } from '../Education/style'
import { RedNote } from '../PersonalInfo/style'
import Date from 'components/Date/Date';
import WorkExpSection from '../../../Resume/Style/WorkExpSection'

const ProjectForm = ({
  form,
  formName,
  onRemove,
  studentFormData,
  isPresent,
  setIsPresent,
  setCorporateName,
  corporateName,
  setCorporateId,
  corporateId,
  getListOfSkills,
  setSkillLoading,
  skillLoading,
  getCorporateList,
  SkillsAPI,
  allSkills,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
  isCvTrue,
  searchAPI,
  isExpUpdated,
  pendingFields,
  hasPendingChanges,
}) => {
  const hasFieldPending = (fieldName) => {
    return pendingFields && pendingFields[fieldName] !== undefined
  }
  let errorCompany = `${formName}Company`
  let errorRole = `${formName}Role`
  let errorFunction = `${formName}Funtion`
  let errorIndustry = `${formName}Industry`
  const [errorNote, setErrorNote] = useState()
  const [show, setShow] = useState(true)
  const [projectTitle, setProjectTitle] = useState(
    form.getFieldValue([[formName], 'title'])
  )

  const [listOfSkills, setListOfSkills] = useState(allSkills ?? [])
  const [storeSkill, setStoreSkill] = useState([])
  const [functionsList, setFunctionsList] = useState([])
  const [roleList, setRoleList] = useState([])
  const [industryList, setIndustryList] = useState([])
  const [skillFetch, setSkillFetch] = useState(true)
  const [timeLine, setTimeLine] = useState('')
  const [startDate, setStartDate] = useState(form.getFieldValue([[formName], 'started_in']))
  const [startMonth, setStartMonth] = useState('')
  const [startYear, setStartYear] = useState('')
  const [endDate, setEndDate] = useState(form.getFieldValue([[formName], 'ended_in']))
  const [endMonth, setEndMonth] = useState('')
  const [endYear, setEndYear] = useState('')
  const [noticePeriod, setNoticePeriod] = useState()
  const [description, setDescription] = useState('')
  const [selectedSkill, setSelectedSkill] = useState([])
  const [skillErrorMsg, setSkillErrorMsg] = useState('')
  const [award, setAward] = useState([])
  const [awardList, setAwardList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const [file, setFile] = useState(() => {
    const cert = form.getFieldValue([[formName], 'certificate'])
    return cert && (cert.url || cert.size) ? cert : null
  })
  const [isJobType, setIsJobType] = useState(
    form.getFieldValue([[formName], 'jobType'])
  )
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(
    mumericToBooleanConverter(
      form.getFieldValue([[formName], 'isCurrentlyWorking'])
    )
  )
  const [dateErrorMsg, setDateErrorMsg] = useState('')
  const [workErrorMsg, setWorkErrorMsg] = useState('')
  const [roleSearch, setRoleSearch] = useState('')
  const [functionSearch, setFunctionSearch] = useState('')
  const [options, setOptions] = useState([])
  const [optionsFunction, setOptionsFunction] = useState([])
  const [compSearch, setCompSearch] = useState('')

  const currentYear = moment().year()
  const [deleted, setDeleted] = useState(false)

  const years = []
  for (let year = currentYear; year >= 1923; year--) {
    years.push({
      value: year,
      name: year,
    })
  }
  useEffect(() => {
    if (roleList) {
      setOptions(roleList)
    }
  }, [roleList])

  useEffect(() => {
    if (roleSearch) {
      const lowercaseRoleSearch = roleSearch?.toLowerCase()
      if (roleSearch?.length > 0) {
        if (
          !options?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()
            return lowercaseOptionName === lowercaseRoleSearch
          })
        ) {
          setOptions(prev => [{ name: roleSearch, id: '' }, ...prev])
        }
      }
      form.setFieldsValue({ [formName]: { role: '' } })
    }
  }, [roleSearch, options, roleList])

  useEffect(() => {
    if (functionSearch) {
      const lowercaseFunctionSearch = functionSearch?.toLowerCase()
      if (functionSearch?.length > 0) {
        if (
          !optionsFunction?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()
            return lowercaseOptionName === lowercaseFunctionSearch
          })
        ) {
          setOptionsFunction(prev => [{ name: functionSearch, id: '' }, ...prev])
        }
      }
      form.setFieldsValue({ [formName]: { function: '' } })
    }
  }, [functionSearch, optionsFunction, functionsList])
  useEffect(() => {
    setOptionsFunction(functionsList)
  }, [functionsList])
  useEffect(() => {
    if (industryList.length === 0) {
      setIndustryList([
        {
          name: 'Other',
          id: 'OTHER',
          isActive: 'true',
        },
        ...industryList,
      ])
    }
  }, [industryList])

  const RadioOptions = [
    {
      id: 1,
      label: 'Full-time',
      value: 'FULL_TIME',
    },
    {
      id: 2,
      label: 'Part-time',
      value: 'PART_TIME',
    },
  ]

  useLayoutEffect(() => {
    updateCorporateData()
    updateDesignationData()
    updateFunctionData()
    updateIndustryData()
  }, [])

  useEffect(() => {
    form.setFieldValue([[formName], 'shown'], true)
    setAwardList(form.getFieldValue([[formName], 'awards']))
  }, [])

  useEffect(() => {
    let listData = []
    if (awardList !== undefined) {
      awardList.forEach((data, index) => {
        let formName1 = formName + '_award_' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description
        form.setFieldsValue({
          [formName1]: {
            title: data?.title,
            awarded_on: data?.awarded_on,
            description: formattedDescription,
            certificate: data?.certificate,
          },
        })
        listData.push({
          component: WorkExpAwardForm,
          formName: formName1,
        })
      })

      setAward(listData)
    }
  }, [awardList])
  useEffect(() => {
    let updatedList = []
    let formDatas = form.getFieldValue()
    Object.entries(formDatas).forEach(([name, item]) => {
      if (name.includes('award') && name.includes(formName)) {
        form.setFieldValue({
          [name]: {
            ...item,
          },
        })
        updatedList.push({
          component: WorkExpAwardForm,
          formName: name,
        })
      }
    })

    setAward(updatedList)
  }, [isExpUpdated])

  useLayoutEffect(() => {
    const startedIn = form.getFieldValue([[formName], 'started_in'])
    if (
      startedIn &&
      startedIn != undefined &&
      moment(startedIn, 'MM/YYYY', true).isValid()
    ) {
      const dateParts = startedIn.split('/')
      setStartMonth(dateParts[0])
      setStartYear(dateParts[1])
      form.setFieldsValue({ [formName]: { startMonth: dateParts[0] } })
      form.setFieldsValue({ [formName]: { startYear: dateParts[1] } })
      //setStartDate(moment(form.getFieldValue([[formName], 'started_in'])))
    }

    const endedIn = form.getFieldValue([[formName], 'ended_in'])

    if (
      endedIn &&
      endedIn != undefined &&
      moment(endedIn, 'MM/YYYY', true).isValid()
    ) {
      const dateParts = endedIn.split('/')
      setEndMonth(dateParts[0])
      setEndYear(dateParts[1])
      form.setFieldsValue({ [formName]: { endMonth: dateParts[0] } })
      form.setFieldsValue({ [formName]: { endYear: dateParts[1] } })
      setEndDate(moment(form.getFieldValue([[formName], 'ended_in'])))
    }
    if (form.getFieldValue([[formName], 'noticePeriod']) != undefined) {
      setNoticePeriod(form.getFieldValue([[formName], 'noticePeriod']))
    }
    setIsCurrentlyWorking(
      mumericToBooleanConverter(
        form.getFieldValue([[formName], 'isCurrentlyWorking'])
      )
    )

    updateSkillsData()
  }, [form.getFieldValue([[formName], 'started_in'])])

  const onBlurProjectTitle = e => {
    if (e.target.value.trim()) {
      form.setFieldsValue({ [formName]: { title: e.target.value?.trim() } })
      setProjectTitle(e.target.value?.trim())
    } else {
      form.setFieldsValue({ [formName]: { title: '' } })
      setProjectTitle('')
    }
  }

  const onDateChange = (date, dateString) => {
    form.setFieldsValue({ [formName]: { started_in: dateString } })
   // form.setFieldsValue({ [level]: { endedYear: dateString } })
    setStartDate(dateString)
    //setStartDate(date)
  }

  const onDateChangeEnd = (date, dateString) => {
    form.setFieldsValue({ [formName]: { ended_in: dateString } })
   // form.setFieldsValue({ [level]: { endedYear: dateString } })
    setEndDate(dateString)
    //setStartDate(date)
  }

  const validator = (rule, value) => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )

    const isStartMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'startMonth'])
      ) !== undefined
    const isStartYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'startYear'])
      ) !== undefined
    const isEndMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'endMonth'])
      ) !== undefined
    const isEndYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'endYear'])
      ) !== undefined

    const now = moment()

    if (
      form.getFieldValue([[formName], 'startMonth']) === undefined ||
      !isStartMonthInList
    ) {
      // setDateErrorMsg(' Please select StartMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select StartMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'startYear']) === undefined ||
      !isStartYearInList
    ) {
      // setDateErrorMsg(' Please select StartYear')
      form.setFieldsValue({ [formName]: { error: 'Please select StartYear' } })
      return Promise.reject(new Error(''))
    } else if (startDate > now) {
      setDateErrorMsg(' Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'endMonth']) === undefined ||
      !isEndMonthInList
    ) {
      // setDateErrorMsg(' Please select EndMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select EndMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'endYear']) === undefined ||
      !isEndYearInList
    ) {
      // setDateErrorMsg(' Please select EndYear')
      form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      return Promise.reject(new Error(''))
    } else if (endDate > now) {
      setDateErrorMsg(' End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (endDate < startDate) {
      setDateErrorMsg('End date cannot be before start date')
      form.setFieldsValue({
        [formName]: { error: 'End date cannot be before start date' },
      })
      return Promise.reject(new Error(''))
    } else {
      setDateErrorMsg('')
      return Promise.resolve()
    }
  }

const validatorEndDate = (rule, value) => {
    const now = moment()

    // Get the form values directly
    const start = form.getFieldValue([[formName], 'started_in'])
    const end = form.getFieldValue([[formName], 'ended_in'])
    
    // Future date check for start date
    if (start && moment(start, 'MM/YYYY').isAfter(now)) {
      setDateErrorMsg('Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject('Start Date cannot be in the future')
    }
    // Future date check for end date
    if (end && moment(end, 'MM/YYYY').isAfter(now)) {
      setDateErrorMsg('End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
      return Promise.reject('End Date cannot be in the future')
    }

    // Only do the comparison if both dates exist
    if (start && end) {
      // Check if end date is before start date using moment
      if (moment(end, 'MM/YYYY').isBefore(moment(start, 'MM/YYYY'))) {
        setDateErrorMsg('End date cannot be before start date')
        form.setFieldsValue({
          [formName]: { error: 'End date cannot be before start date' },
        })
        return Promise.reject('End date cannot be before start date')
      }
    }
    
    setDateErrorMsg('')
    return Promise.resolve()
  }


  const onStartMonthChange = data => {
    setStartMonth(data)
    form.setFieldsValue({ [formName]: { startMonth: data } })
  }
  const onStartYearChange = data => {
    setStartYear(data)
    form.setFieldsValue({ [formName]: { startYear: data } })
  }

  const onEndMonthChange = data => {
    setEndMonth(data)
    form.setFieldsValue({ [formName]: { endMonth: data } })
  }
  const onEndYearChange = data => {
    setEndYear(data)
    form.setFieldsValue({ [formName]: { endYear: data } })
  }

  const onNoticePeriodChange = data => {
    setNoticePeriod(data)
    form.setFieldsValue({ [formName]: { noticePeriod: data } })
  }

  const onFunctionChange = (data, option) => {
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorFunction]: '',
    }))
    form.setFieldsValue({ [formName]: { function: data } })
    setFunctionSearch('')
  }

  const onRoleChange = data => {
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorRole]: '',
    }))
    form.setFieldsValue({ [formName]: { role: data } })
    setRoleSearch('')
  }

  const onIndustryChange = (data, option) => {
    if (data?.toUpperCase() === 'OTHER') {
      form.setFieldsValue({ [formName]: { addIndustry: 'OTHER' } })
      form.setFieldsValue({ [formName]: { industry: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { addIndustry: null },
      })
      form.setFieldsValue({ [formName]: { industry: option?.option?.name } })
    }
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorIndustry]: '',
    }))
    if (!data) {
      industrySearching()
    }
  }
  const onSkillChange = (value, id) => {
    let list = []
    let skillList = []

    for (const item of id) {
      list.push(item?.id)
      let obj = {
        name: item?.name,
        id: item?.id,
      }
      skillList.push(obj)
    }
    setSelectedSkill(list)
    setStoreSkill(skillList)
    form.setFieldsValue({ [formName]: { skill_set: skillList } })
    delaySkillToFetch('')
    if (skillList.length > 20) {
      setSkillErrorMsg('Maximum 20 Skills only allowed')
    } else {
      // Clear the error message if skillList is within the limit
      setSkillErrorMsg('')
    }
  }

  const onChangeDescription = data => {
    form.setFieldsValue({ [formName]: { description: data } })
    setDescription(data)
  }

  const NoticePeriodList = []
  for (let year = 1; year <= 100; year++) {
    NoticePeriodList.push({
      value: year,
      name: year,
    })
  }

  const getFormName = level => {
    let name = level.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }
  const showHandler = () => {
    show ? setShow(false) : setShow(true)
    form.setFieldValue([[formName], 'shown'], show ? false : true)
  }

  const getTitle = formName => {
    if (formName?.includes('project')) {
      return 'Project'
    } else if (formName?.includes('internship')) {
      return 'Internship'
    } else if (formName?.includes('experience')) {
      return 'Experience'
    } else if (formName?.includes('course')) {
      return 'Course'
    }
  }

  const updateSkillsData = () => {
    let sillsList = form?.getFieldValue([[formName], 'skill_set']) || []
    let newSkillSet = []
    if (sillsList?.length && listOfSkills?.length && Array.isArray(sillsList)) {
      for (let skill of sillsList) {
        if (skill?.name && !skill?.id) {
          let skillObj = getValuebyName(listOfSkills, skill?.name)
          if (skillObj) {
            skill.id = skillObj.id

            newSkillSet.push({ id: skillObj?.id, name: skillObj?.name })
          }
        } else {
          newSkillSet.push(skill)
        }
      }
      form.setFieldsValue({
        [formName]: { skill_set: newSkillSet?.length ? newSkillSet : [] },
      })
      setSelectedSkill(
        newSkillSet ? newSkillSet?.map(({ id }) => id) || [] : []
      )
      setStoreSkill(newSkillSet || [])
    } else if (storeSkill?.length) {
      form.setFieldsValue({ [formName]: { skill_set: storeSkill } })
    }
    setTimeout(() => {
      setSkillFetch(false)
    }, 200)
  }

  useEffect(() => {
    updateSkillsData()
  }, [listOfSkills])

  const skillSearching = async (skillName = '') => {
    try {
      const result = await SkillsAPI(skillName);

      setListOfSkills(!skillName ? allSkills : result)
    } catch (err) {
      console.log(err)
    }
  }

  const delaySkillToFetch = useCallback(
    debounce(data => {
      skillSearching(data)
    }, 500),
    []
  )

  useEffect(() => {
    // Ensure certificate is always an object structure
    const certificateObject = file && typeof file === 'string'
      ? { url: file, name: 'Certificate.jpg' }
      : (file && (file?.size || file?.url)) ? file : null

    form.setFieldsValue({ [formName]: { certificate: certificateObject } })
  }, [file])
  useEffect(() => {
    if ((startDate && endDate) || isCurrentlyWorking) {
      setTimeLine(
        `${
          moment(
            form.getFieldValue([[formName], 'started_in']),
            'MM/YYYY'
          ).format('MMMM YYYY') +
          (isCurrentlyWorking
            ? '- Present'
            : endMonth
            ? '-' +
              moment(
                form.getFieldValue([[formName], 'ended_in']),
                'MM/YYYY'
              ).format('MMMM YYYY')
            : '')
        }`
      )
    }
  }, [startDate, endDate, isCurrentlyWorking])

  const awardHandle = (isAdd, isDelete, deleteForm) => {
    let awardLength = award?.length

    let arr = []
    let formName1 = formName + '_award_' + awardLength
    if (isAdd) {
      form.setFieldsValue({ [formName1]: null })
      arr.push({ component: WorkExpAwardForm, formName: formName1 })

      setAward(exp => exp.concat(arr))
    }
    if (isDelete) {
      form.setFieldsValue({
        [deleteForm]: null,
      })
      let updatedList = []
      award
        ?.filter(data => data?.formName !== deleteForm)
        .forEach((item, index) => {
          let formName1 = formName + '_award_' + index
          let currentFormValue = form.getFieldValue([item.formName])
          form.setFieldsValue({
            [item.formName]: null,
          })
          form.setFieldsValue({
            [formName1]: {
              ...currentFormValue,
            },
          })
          updatedList.push({
            component: WorkExpAwardForm,
            formName: formName1,
          })
        })

      setAward(updatedList)
    }
  }

  const functionSearching = async (functionName = '') => {
    try {
      if (functionName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorFunction]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.function?.name,
        functionName,
        searchConfig?.function
      )
      let list = res || []
      setFunctionsList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }
  const designationSearching = async (designationName = '') => {
    try {
      if (designationName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorRole]: '',
        }))
      }
      const res = await getDesignationsList(designationName)
      let list = res?.data?.data?.list || []
      setRoleList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }
  const industrySearching = async (industryName = '') => {
    try {
      if (industryName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorIndustry]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.industries?.name,
        industryName,
        searchConfig?.industries
      )
      let list = res || []
      setIndustryList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }

  const delayFunctionToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'function'], '')
      await functionSearching(data)
    }, 500),
    []
  )

  const delayCompanyToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'company'], '')
      await companySearching(data)
    }, 500),
    []
  )

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }
  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      await functionSearching(functionSearch)
    }, 500)
    return () => clearTimeout(getData)
  }, [functionSearch])

  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      await designationSearching(roleSearch)
    }, 500)
    return () => clearTimeout(getData)
  }, [roleSearch])

  const delayIndustryToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'industry'], '')

      await industrySearching(data)
    }, 500),
    []
  )

  // useEffect(() => {
  //   if (startMonth && startYear) {
  //     let date = startMonth + '/' + startYear
  //     form.setFieldsValue({ [formName]: { started_in: date } })
  //     setStartDate(date)
  //   }
  // }, [startMonth, startYear])

  // useEffect(() => {
  //   if (endMonth && endYear) {
  //     let date = endMonth + '/' + endYear
  //     form.setFieldsValue({ [formName]: { ended_in: date } })
  //     setEndDate(date)
  //   }
  // }, [endMonth, endYear])

  const validateSkill = (rule, value, callback) => {
    if (form?.getFieldValue([[formName], 'skill_set'])?.length > 20) {
      setSkillErrorMsg('')
      return Promise.reject(new Error('Maximum 20 Skills only allowed'))
    } else {
      return Promise.resolve()
    }
  }

  const countRichTextCharacters = richText => {
    if (!richText) return 0
    
    const textString = typeof richText === 'string' ? richText : String(richText)
    
    // Remove HTML tags using a regular expression
    const plainText = textString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText.length || 0

    return characterCount
  }

  const isCurrentlyOnChange = data => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )

    const now = moment()
    setIsCurrentlyWorking(data?.target?.checked)
    form.setFieldsValue({
      [formName]: {
        isCurrentlyWorking: data?.target?.checked,
      },
    })
    setIsPresent(data?.target?.checked)
    if (data?.target?.checked) {
      setEndYear('')
      setEndMonth('')
      setEndDate('')
      form.setFieldsValue({ [formName]: { endYear: '' } })
      form.setFieldsValue({ [formName]: { ended_in: '' } })
      form.setFieldsValue({ [formName]: { endMonth: '' } })
      if (
        form.getFieldValue([[formName], 'endYear']) === null ||
        form.getFieldValue([[formName], 'endMonth']) === null ||
        form.setFieldsValue({ [formName]: { ended_in: '' } }) ||
        endDate > now ||
        endDate < startDate
      ) {
        setWorkErrorMsg('')
        form.setFieldsValue({
          [formName]: { error: '' },
        })
      }
    } else if (!data?.target?.checked) {
      if (
        form.getFieldValue([[formName], 'endYear']) === '' ||
        form.getFieldValue([[formName], 'endYear']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndYear')
        form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      }
      if (
        form.getFieldValue([[formName], 'endMonth']) === '' ||
        form.getFieldValue([[formName], 'endMonth']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndMonth')
        form.setFieldsValue({
          [formName]: { error: 'Please select EndMonth' },
        })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate > now
      ) {
        setWorkErrorMsg(' End Date cannot be in the future')
        form.setFieldsValue({
          [formName]: { error: 'End Date cannot be in the future' },
        })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate < startDate
      ) {
        setWorkErrorMsg('End date cannot be before start date')
        form.setFieldsValue({
          [formName]: { error: 'End date cannot be before start date' },
        })
      }
    }
  }

  const jobTypeOnchange = data => {
    if (data === false) {
      form.setFieldsValue({ [formName]: { jobType: '' } })
    }
    setIsJobType(data)
    form.setFieldsValue({ [formName]: { jobType: data } })
  }

  const companySearching = async (companyName = '') => {
    try {
      if (companyName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorCompany]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.companyMaster?.name,
        companyName,
        searchConfig?.companyMaster
      )
      let list = res || [];
      let data = [
        {
          companyName: companyName,
          id: '',
          shortName: '',
        }
      ];
      
      if (list.length === 0) {
        setCompanyList(data);
      } else {
        setCompanyList([data, ...list]);
      }
      
      return list
    } catch (err) {
      console.log(err)
    }
  }

  const onCorporateChange = (data, option) => {
    if (option?.option?.companyName?.trimStart()) {
      setCorporateName(option?.option?.companyName)
      setCorporateId(option?.option?.id)
      form.setFieldsValue({
        [formName]: { organization: option?.option?.companyName },
      })
      form.setFieldsValue({ [formName]: { corporateId: option?.option?.id } })
      setErrorNote(prevErrorNote => ({
        ...prevErrorNote,
        [errorCompany]: '',
      }))
    } else {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })

      setCorporateName('')
      setCorporateId('')
    }
    setCompSearch('')
    delayCompanyToFetch('')
  }

  const onCorporateBlur = () => {
    if (!compSearch == '') {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })
      setCorporateName('')
      setCorporateId('')
      setCompSearch('')
    }
  }

  const onBlurHandler = key => {
    if (!form.getFieldValue([[formName], [key]])?.trim()) {
      form.setFieldsValue({ [formName]: { [key]: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { [key]: form.getFieldValue([[formName], [key]])?.trim() },
      })
    }
  }
  // useEffect(() => {
  //   let getData
  //   getData = setTimeout(async () => {
  //     const res = await searchAPI(
  //       searchConfig?.companyMaster?.name,
  //       compSearch,
  //       searchConfig?.companyMaster
  //     )
  //     let list = res || []
  //     setCompanyList(list)
  //   }, 500)
  //   return () => clearTimeout(getData)
  // }, [compSearch])

  useEffect(() => {
    if (compSearch) {
      const lowercaseCompSearch = compSearch?.toLowerCase()
      if (compSearch?.length > 0) {
        if (
          !companyList?.some(option => {
            const lowercaseOptionName = option?.companyName?.toLowerCase()
            return lowercaseOptionName === lowercaseCompSearch
          })
        ) {
          setCompanyList(prev => [{ companyName: compSearch, id: '' }, ...prev])
        }
      }
    }
  }, [compSearch, companyList])
  // useEffect(() => {
  //   let getData
  //   getData = setTimeout(async () => {
  //     const res = await searchAPI(
  //       searchConfig?.companyMaster?.name,
  //       compSearch,
  //       searchConfig?.companyMaster
  //     )
  //     let list = res || []
  //     setCompanyList(list)
  //   }, 500)
  //   return () => clearTimeout(getData)
  // }, [compSearch])

  const updateCorporateData = async () => {
    let corporateId = form.getFieldValue([[formName], 'corporateId'])
    let companyName = form.getFieldValue([[formName], 'organization'])
    const results = await companySearching(companyName)

    if (!corporateId && companyName && isCvTrue) {
      if (results?.length > 0) {
        const corporateObj = results[0]
        if (corporateObj?.companyName?.toLowerCase()?.trim() == companyName?.toLowerCase()?.trim() || results?.length === 1) {
          if (corporateObj) {
            form.setFieldValue([[formName], 'corporateId'], corporateObj?.id)
            form.setFieldValue([[formName], 'organization'], corporateObj?.companyName)
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorCompany]: results?.length
              ? `Searched results for : ${companyName}`
              : `No data matched for : ${companyName}`,
          }))
          if (!results?.length) companySearching('')
          form.setFieldValue([[formName], 'organization'], '')
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          [errorCompany]: results?.length
            ? `Searched results for : ${companyName}`
            : `No data matched for : ${companyName}`,
        }))
        if (!results?.length) companySearching('')
        form.setFieldValue([[formName], 'organization'], '')
      }
    } else {
      companySearching('')
    }
  }
  const updateDesignationData = async () => {
    let roleName = form.getFieldValue([[formName], 'role'])
    const results = await designationSearching(roleName)
    if (roleName && roleName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let roleObj = results[0]
          if (
            (results && results?.length == 1) ||
            roleObj?.name?.toLowerCase() == roleName?.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'role'], roleObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorRole]: results?.length
                ? `Searched result for : ${roleName}`
                : `No data matched for : ${roleName}`,
            }))
            form.setFieldValue([[formName], 'role'], '')
            if (!results?.length) designationSearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorRole]: results?.length
              ? `Searched result for : ${roleName}`
              : `No data matched for : ${roleName}`,
          }))
          form.setFieldValue([[formName], 'role'], '')
          if (!results?.length) designationSearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
  const updateFunctionData = async () => {
    let functionName = form.getFieldValue([[formName], 'function'])
    const results = await functionSearching(functionName)
    if (functionName && functionName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let functionObj = results[0]
          if (
            (results && results?.length == 1) ||
            functionObj?.name?.toLowerCase() == functionName?.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'function'], functionObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorFunction]: results?.length
                ? `Searched result for : ${functionName}`
                : `No data matched for : ${functionName}`,
            }))
            form.setFieldValue([[formName], 'function'], '')
            if (!results?.length) functionSearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorFunction]: results?.length
              ? `Searched result for : ${functionName}`
              : `No data matched for : ${functionName}`,
          }))
          form.setFieldValue([[formName], 'function'], '')
          if (!results?.length) functionSearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
  const updateIndustryData = async () => {
    let industryName = form.getFieldValue([[formName], 'industry'])
    const results = await industrySearching(industryName)
    if (industryName && industryName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let industryObj = results[0]
          if (
            (results && results?.length == 1) ||
            industryObj?.name?.toLowerCase() == industryName.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'industry'], industryObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorIndustry]: results?.length
                ? `Searched result for : ${industryName}`
                : `No data matched for : ${industryName}`,
            }))
            form.setFieldValue([[formName], 'industry'], '')
            if (!results?.length) industrySearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorIndustry]: results?.length
              ? `Searched result for : ${industryName}`
              : `No data matched for : ${industryName}`,
          }))
          form.setFieldValue([[formName], 'industry'], '')
          if (!results?.length) industrySearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    setProjectTitle(form.getFieldValue([[formName], 'title']))
  }, [form.getFieldValue([[formName], 'title'])])

  const onRemoveClick = () => {
    setErrorNote({})
    setDeleted(true)
    onRemove(false, true, formName)
  }
  return (
    <>
      {!deleted && (
        <Container column flexStart>
          <Control spaceBetween alignCenter>
            <Control column flexStart gap="10px">
              <Control alignCenter gap="10px">
                <Heading style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                  {projectTitle ? projectTitle : form.getFieldValue([[formName], 'organization'])}
                </Heading>
                {hasPendingChanges && (
                  <CustomTag
                    message="Verification Pending"
                    bordered={true}
                    background={'#eb5d60'}
                    border={'#eb5d60'}
                    color={'#fff'}
                  />
                )}
              </Control>
              <SubHeading>{timeLine ? timeLine : 'Timeline'}</SubHeading>
            </Control>
            <Control gap="10px" flexEnd>
              <IconView onClick={() => onRemoveClick()}>
                <Delete />
              </IconView>
              <IconView onClick={() => showHandler()}>
                <Dropdown />
              </IconView>
            </Control>
          </Control>
          <StyledFormItem show={form.getFieldValue([[formName], 'shown'])}>
            <>
            <Divider />
            <Control row gap="20px" width="100%">
              {/* */}
              {(formName?.includes('experience') || formName?.includes('internship'))  && (
              <Control top="20px" flexStart column width="49%">
                    <FormItem name={[[formName], 'role']}>
                      <div></div>
                    </FormItem>
                    <Label>Role *</Label>
                    <AntdSelectNew
                      rules={[
                        {
                          required: true,
                          message: 'Please select Role!',
                        },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'role']}
                      OptionData={options}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onChange={value => {
                        onRoleChange(value)
                      }}
                      value={form?.getFieldValue([[formName], 'role'])}
                      onSearch={data => setRoleSearch(data?.trim() ?? '')}
                      filterOption={false}
                      onBlur={() => onBlurHandler('role')}
                    />
                    {errorNote?.[errorRole] && (
                      <RedNote>{errorNote?.[errorRole]}</RedNote>
                    )}
                  </Control>
              )}
              {formName?.includes('course') && (
                <Control top="20px" flexStart column width="49%">
                  <Label>Institute Name *</Label>
                  <AntdInput
                    placeholder="Eg. Indian Institute of technology"
                    name={[[formName], 'organization']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter institute name! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                  />
                </Control>
              )}

             
              {!formName?.includes('course') && (
                <Fragment>
                  <Control top="20px" flexStart column width="49%">
                    <Label>
                      {!formName?.includes('project')
                        ? 'Company Name *'
                        : 'Company Name'}
                    </Label>
                    <FormItem name={[[formName], 'organization']} />
                    <FormItem name={[[formName], 'corporateId']} />
                    <AntdSelectNew
                      placeholder="Select Corporate"
                      name={[[formName], 'organization']}
                      nameParam="companyName"
                      valueParam="id"
                      showSearch={true}
                      allowClear={true}
                      OptionData={companyList}
                      rules={[
                        {
                          required: !formName?.includes('project'),
                          message: 'Please select the Corporate.',
                        },
                      ]}
                      filterOption={false}
                      onSearch={data => delayCompanyToFetch(data?.trim() ?? '')}
                      onChange={onCorporateChange}
                      onBlur={onCorporateBlur}
                      value={form.getFieldValue([[formName], 'organization'])}
                      onClear={() => setCompSearch('')}
                    />

                    {errorNote?.[errorCompany] && (
                      <RedNote>{errorNote?.[errorCompany]}</RedNote>
                    )}
                  </Control>

                 
                  {!(
                    formName?.includes('experience') ||
                    formName?.includes('internship')
                  ) && (
                    <Control top="20px" flexStart column width="49%">
                      <Label>
                        Project Title *
                        {hasFieldPending('title') && <PendingIcon />}
                      </Label>
                      <AntdInput
                        placeholder="Please Enter Project Title"
                        name={[[formName], 'title']}
                        maxLength={120}
                        rules={[
                          {
                            min: 3,
                            max: 120,
                            message: `${`Please enter project title! Minimum 3 characters, Maximum 120 characters.`}`,
                          },
                          {
                            required: true,
                            message: 'Please enter the Project title.',
                          },
                        ]}
                        onBlur={onBlurProjectTitle}
                      />
                    </Control>
                  )}
                </Fragment>
              )}
              </Control>
            
              {formName?.includes('course') && (
                <Control top="20px" flexStart column>
                  <Label>Course Name *</Label>
                  <AntdInput
                    placeholder="Please Enter Course Name"
                    name={[[formName], 'title']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter course name! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                  />
                </Control>
              )}
           
              { (formName?.includes('experience') || formName?.includes('internship') ) && (
               <Control row gap="20px" width="100%">
                  {/* <Control top="20px" flexStart column width="49%">
                    <FormItem name={[[formName], 'function']}>
                      <div></div>
                    </FormItem>
                    <Label>Function *</Label>
                    <FormItem name={[[formName], 'function']} />
                    <FormItem name={[[formName], 'addFunction']} />
                    <AntdSelect
                      rules={[
                        {
                          required: true,
                          message: 'Please select Function!',
                        },
                      ]}
                      placeholder="Eg.Operation"
                      name={[[formName], 'function']}
                      OptionData={optionsFunction || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onChange={onFunctionChange}
                      value={form?.getFieldValue([[formName], 'function'])}
                      onSearch={data => setFunctionSearch(data?.trim() ?? '')}
                      filterOption={false}
                      onBlur={() => onBlurHandler('function')}
                    />
                    {errorNote?.[errorFunction] && (
                      <RedNote>{errorNote?.[errorFunction]}</RedNote>
                    )}
                  </Control> */}
          

                 
                  <Control top="20px" flexStart column width="100%">
                    <FormItem name={[[formName], 'industry']}>
                      <div></div>
                    </FormItem>
                    <Label>Industry </Label>
                    <FormItem name={[[formName], 'industry']} />
                    <FormItem name={[[formName], 'addIndustry']} />

                    <AntdSelect
                      rules={[
                        // {
                        //   required: true,
                        //   message: 'Please select industry!',
                        // },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'industry']}
                      OptionData={industryList || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => delayIndustryToFetch(data)}
                      onChange={onIndustryChange}
                      value={
                        form.getFieldValue([[formName], 'addIndustry']) ===
                        'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'industry'])
                      }
                      filterOption={false}
                    />
                    {errorNote?.[errorIndustry] && (
                      <RedNote>{errorNote?.[errorIndustry]}</RedNote>
                    )}
                  </Control>
               
                </Control>
              )}
   {form.getFieldValue([[formName], 'addIndustry']) ===
                    'OTHER' && (
                    <Control top="20px" flexStart column>
                      <Label>Please enter the Industry name</Label>
                      <AntdInput
                        placeholder="Enter the Industry name"
                        name={[[formName], 'industry']}
                        value={form.getFieldValue([[formName], 'industry'])}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the Industry name.',
                          },
                        ]}
                        onChange={e => {
                          // setIsCurrentlyWorking(false)
                        }}
                        onBlur={() => onBlurHandler('industry')}
                      />
                    </Control>
                  )}

  {formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                     
                    <FormItem   rules={[
                                          {
                                            required: true,
                                            message: 'Please select year!',
                                          },
                                          { validator: validatorEndDate }
                                        ]} name={[[formName], 'started_in']}>
                                            <Label>
                                              Started *
                                              {hasFieldPending('started_in') && <PendingIcon />}
                                            </Label>
                                         <Date
                                          style={{ marginTop: '8px' }}
                                       
                                                            placeholder="Please Select the year"
                                                            onChange={onDateChange}
                                                            format="MM/YYYY"
                                                            picker="month"
                                                            defaultValue={startDate ? moment(startDate, "MM/YYYY") : null}
                                                          // value={startDate ? moment(startDate) : null}
                                                            inputReadOnly
                                                              disabledDate={d => !d || d.isAfter(moment())}
                                                          />
                                          </FormItem>
                    </Control>
                    {isCurrentlyWorking && (
                    <Control flexStart column>
                      <FormItem name={[[formName], 'noticePeriod']}>
                        <div></div>
                      </FormItem>
                      <Label> Notice Period (In Days) *</Label>
                      <AntdSelect
                        placeholder="Eg.0-15"
                        name={[[formName], 'noticePeriod']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Notice Period!',
                          },
                        ]}
                        OptionData={NoticePeriodList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => onNoticePeriodChange(value)}
                        value={noticePeriod}
                      />
                    </Control>
                  )}
                  {!isCurrentlyWorking && (
                    <Control flexStart column>
                      
                    <FormItem   rules={[
                                          {
                                            required: true,
                                            message: 'Please select year!',
                                          },
                                        ]} name={[[formName], 'ended_in']}>
                                            <Label>
                                              Ended *
                                              {hasFieldPending('ended_in') && <PendingIcon />}
                                            </Label>
                                         <Date
                                          style={{ marginTop: '8px' }}
                                       
                                                            placeholder="Please Select the year"
                                                            onChange={onDateChangeEnd}
                                                            format="MM/YYYY"
                                                            picker="month"
                                                            defaultValue={endDate ? moment(endDate, "MM/YYYY") : null}
                                                          // value={endDate ? moment(endDate) : null}
                                                            inputReadOnly
                                                              disabledDate={d => !d || d.isAfter(moment())}
                                                          />
                                          </FormItem>
                    </Control>
                  )}
                  </Control>

                  <FormItem name={[[formName], 'started_in']} />

                  {(!isPresent || isCurrentlyWorking) && (
                    <Control spaceBetween top="20px" gap="20px">
                      <Control flexStart column></Control>
                      <Control flexStart column>
                        <Checkbox
                          onChange={isCurrentlyOnChange}
                          checked={isCurrentlyWorking}
                        >
                          {'I am currently working'}
                        </Checkbox>
                      </Control>
                    </Control>
                  )}

                  <FormItem name={[[formName], 'isCurrentlyWorking']} />
                 

                  {workErrorMsg && (
                    <p style={{ color: 'red' }}>{workErrorMsg}</p>
                  )}

               
                </Fragment>
              )}
 {formName?.includes('experience') && (
                    <Control top="20px" flexStart column>
                      
                      <Label>Job Type *</Label>
                      <FormItem
                        name={[[formName], 'jobType']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select the job type',
                          },
                        ]}
                      >
                        <RadioGroupNew
                          onChange={({ target }) =>
                            jobTypeOnchange(target.value)
                          }
                          defaultValue={isJobType}
                        >
                          {RadioOptions?.map((item, index) => (
                            <Radio
                              width={'50%'}
                              key={index}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                            />
                          ))}
                        </RadioGroupNew>
                      </FormItem>
                    </Control>
                  )}
              {!formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      {/* <Label>Start Month* </Label>
                      <FormItem name={[[formName], 'startMonth']}>
                        <div></div>
                      </FormItem>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'startMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Month!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartMonthChange(value)
                          form.validateFields(
                            [[formName], 'startMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].startMonth.errors[0]
                                    .message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'startMonth'])}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        disable={false}
                      /> */}

                          <FormItem   rules={[
                                          {
                                            required: true,
                                            message: 'Please select year!',
                                          },
                                        ]} name={[[formName], 'started_in']}>
                                            <Label> Started *</Label>
                                         <Date
                                          style={{ marginTop: '8px' }}
                                       
                                                            placeholder="Please Select the year"
                                                            onChange={onDateChange}
                                                            format="MM/YYYY"
                                                            picker="month"
                                                            defaultValue={startDate ? moment(startDate, "MM/YYYY") : null}
                                                          // value={startDate ? moment(startDate) : null}
                                                            inputReadOnly
                                                              disabledDate={d => !d || d.isAfter(moment())}
                                                          />
                                          </FormItem>
                    </Control>

                    <Control flexStart column>
                    <FormItem   rules={[
                                          {
                                            required: true,
                                            message: 'Please select year!',
                                          },
                                          { validator: validatorEndDate }
                                        ]} name={[[formName], 'ended_in']}>
                                            <Label> Ended *</Label>
                                         <Date
                                          style={{ marginTop: '8px' }}
                                       
                                                            placeholder="Please Select the year"
                                                            onChange={onDateChangeEnd}
                                                            format="MM/YYYY"
                                                            picker="month"
                                                            defaultValue={endDate ? moment(endDate, "MM/YYYY") : null} 
                                                            //value={endDate ? moment(endDate) : null}
                                                            inputReadOnly
                                                            disabledDate={d => !d || d.isAfter(moment())}
                                                          />
                                          </FormItem>
                    </Control>
                  </Control>

             
                </Fragment>
              )}
             {/* {formName?.includes('experience') && (
                <Control top="20px" flexStart column >
                  <Label>Job Title *</Label>
                  <AntdInput
                    placeholder="Please Enter Job Title"
                    name={[[formName], 'title']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter job title! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                    onBlur={onBlurProjectTitle}
                  />
                </Control>
              )} */}
              <Control top="20px" flexStart column>
                <FormItem name={[[formName], 'skill_set']}>
                  <div></div>
                </FormItem>
                <Label>Skills </Label>
                <AntdSelect
                  placeholder="Eg.React.js"
                  name={[[formName], 'skill_set']}
                  rules={[
                    // {
                    //   validator: async (_, value) => {
                    //     if (!selectedSkill?.length) {
                    //       if (!Array.isArray(value)) {
                    //         return Promise.reject('Please select skills!')
                    //       } else if (value?.length === 0) {
                    //         return Promise.reject('Please select skills!')
                    //       }
                    //     }
                    //     return Promise.resolve()
                    //   },
                    // },
                    // {
                    //   validator: validateSkill,
                    // },
                  ]}
                  OptionData={listOfSkills}
                  valueParam="id"
                  nameParam="name"
                  onChange={(value, id) => onSkillChange(value, id)}
                  value={selectedSkill}
                  mode="multiple"
                  disabled={skillFetch}
                  showSearch={true}
                  onSearch={data => {
                    delaySkillToFetch(data)}
                  }
                  filterOption={false}
                  onDropdownVisibleChange={open => {
                    if (!open) {
                      delaySkillToFetch('')
                      form.setFieldsValue({
                        [formName]: { skill_set: storeSkill },
                      })
                    }
                  }}
                />
                {skillErrorMsg && (
                  <p style={{ color: 'red' }}>{skillErrorMsg}</p>
                )}
                {'Skills: ' + selectedSkill?.length + ' / 20'}
              </Control>
              <Control top="20px" flexStart column>
                <Label>Description</Label>
                <FormItem
                  name={[[formName], 'description']}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (countRichTextCharacters(value) > 1000) {
                          return Promise.reject(
                            'Maximum 1000 Character allowed!'
                          )
                        }

                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <RichEditor
                    value={description}
                    onChange={onChangeDescription}
                  />
                </FormItem>
                {'Characters: ' +
                  countRichTextCharacters(
                    form.getFieldValue([[formName], 'description'])
                  ) +
                  ' / 1000'}
              </Control>            
            </>
            {(formName?.includes('project') || formName?.includes('internship') || formName?.includes('experience'))&& (
                <Control flexStart column top="20px">
                  <FormItem name={[[formName], 'certificate']} noStyle>
                    <Label>Certificate</Label>

                    {file ? (
                      <Control column top="10px" center>
                        <FileReaderVisible
                          file={file}
                          setFile={(val) => {
                            // this is what FileReaderVisible expects
                            setFile(val)
                            form.setFieldsValue({
                              [formName]: {
                                certificate: val,
                              },
                            })
                            setIsUpdateButtonEnabled(false)
                          }}
                        />
                      </Control>
                    ) : (
                      <Control column top="10px" center>
                        <Uploadloader
                          key="certificate-upload"
                          variant="simple"
                          label="Upload Certificate"
                          file={null}
                          setFile={uploadedFile => {
                            setFile(uploadedFile)
                            setIsUpdateButtonEnabled(false)
                            form.setFieldsValue({
                              [formName]: { certificate: uploadedFile },
                            })
                          }}
                          fileName={`${studentFormData?.admin?.firstName
                            ?.toLowerCase()
                            ?.replace(/\s/g, '')}_${getFormName(formName)}_certificate`}
                          onlyDoc={false}
                        />
                      </Control>
                    )}
                  </FormItem>
                </Control>
              )}
          </StyledFormItem>
       
        </Container>
      )}
    </>
  )
}

export default ProjectForm
